import React, { useEffect, useState } from 'react'
import {AiOutlineLineChart} from 'react-icons/ai'
import { Line } from 'react-chartjs-2'
import { Chart, registerables } from 'chart.js';
import moment from 'moment'
import utils from '../../utils';

function UsersJoinChart(props) {
    Chart.register(...registerables);
    const [chartData, setChartData] = useState()
    const userData = props.chartData

    useEffect(() => {
        if (userData?.user_month_aggregate) {
            setChartData({
                labels: userData?.user_month_aggregate.map((item) => (moment(item?.month, 'Y M').format('MMM YYYY'))),
                datasets: [{
                    label: 'User Join Chart',
                    data: userData?.user_month_aggregate.map((item) => (item.count)),               
                }],
            })
        }
    }, [userData])
    useEffect(() => {}, [chartData])
    return (
        <div className='bg-base-100 rounded-md p-3'>
            <div className="flex">
                <AiOutlineLineChart className='font-bold text-2xl mr-3'/>
                <p className="font-bold">User Creation Chart</p>
            </div>
            <div className=''>
                <div style={{"height": "45vh"}}>
                    {chartData && (
                        <Line 
                            data={chartData} 
                            options={utils.chartOptions}/>
                    )}
                </div>
            </div>
        </div>
    )
}

export default UsersJoinChart